import { LicenseType } from "../_models/LicenseType";

export class LicenseTypeMapper {
    static allServerToLocal(serverLicenseTypes = []) {
        return serverLicenseTypes.map(this.serverToLocal);
    }

    static serverToLocal(serverLicenseType) {
        return LicenseType({
            uid: serverLicenseType.uid,
            name: serverLicenseType.name,
            typeFunctionality: serverLicenseType.type_functionality,
            typeDuration: serverLicenseType.type_duration,
            duration: serverLicenseType.duration,
            numRemainingLicenses: serverLicenseType.num_remaining_licenses,
            numAssignedLicenses: serverLicenseType.num_assigned_licenses,
            numTotaLicenses: serverLicenseType.num_total_licenses,
            isDemo: serverLicenseType.is_demo,
            isEnabled: serverLicenseType.is_enabled,
        });
    }
}
